export default "__VITE_ASSET__abaf2098__"